import types from './types';

import moment from 'moment'

const DEFAULT_DATE_STRING = moment().format('YYYY-MM-DD')

const initialState = {
	current: null,
	profile: null,
	date: new Date(),
	dateString: DEFAULT_DATE_STRING,
	schedules: {}, // this is for the main calendar page
	categories: [], // this is for manage calendar
	activated: {}, // this is for manage calendar
	staged: [],
	stagedActivated: {},
	stagedDate: {},
	toth: {},
	loading: true,
	selectedDate: ''
};

export default (state = initialState, action) => {
	switch (action.type) {
		/* Set search term  */
		case types.UPDATE_CURRENT_CHAT:
			return {
				...state,
				current: action.payload
			};

		// updates categories and activated for manage calendar page.
		// Stores activated with date	as key
		case types.UPDATE_CATEGORIES:
			const updateActivated = action.payload.map(item => item.activated)

			let date = state.dateString
			if(updateActivated.length > 0){
				date = updateActivated[0].date
			}
			const newUpdateActivated = {
				...state.activated,
				[date]: updateActivated
			}
			// const date = action.payload.activated.date
			// const activated = action.payload.ac
			return {
				...state,
				loading: false,
				categories: action.payload,
				staged: action.payload.map(item => ({...item, activated: {schedule: []}})),
				stagedDate: {
					...state.stagedDate,
					[state.dateString]: action.payload
				},
				activated: newUpdateActivated
			}
		case types.UPDATE_CATEGORY_SCHEDULE:
			const newSchedule = {
				...state.schedules,
				[action.payload.category]: action.payload.schedule
			}
			return {
				...state,
				schedules: newSchedule
			}
		case types.UPDATE_CURRENT_DATE:
			const newDateString = moment(action.payload).format('YYYY-MM-DD')
			let newStaged = state.stagedDate[newDateString]
			if(!newStaged){
				newStaged = state.staged
			}
			return {
				...state,
				date: action.payload,
				dateString: newDateString,
				staged: newStaged
			}

	  // updates staged manage calendar changes
		// splits the categories from activated by date
		case types.UPDATE_STAGED_CHANGES:
			const newStagedActivated = action.payload.map(item => item.activated)
			const newStagedCategories = action.payload.map(item => {
				// delete item.activated
				return item
			})
			let stagedDate = state.dateString
			if(newStagedActivated.length > 0){
				stagedDate = newStagedActivated[0].date
			}
			const updatedNewStagedActivated = {
				...state.stagedActivated,
				[stagedDate]: newStagedActivated
			}
			return {
				...state,
				staged: newStagedCategories,
				stagedActivated: updatedNewStagedActivated,
				stagedDate: {
					...state.stagedDate,
					[stagedDate]: action.payload
				}
			}

		case types.RESET_STAGED_CHANGES:
			return {
				...state,
				staged: state.categories
			}
		case types.UPDATE_TOTH:
			const newToth = {
				...state.toth,
				[action.payload.date]: action.payload
			}
			return {
				...state,
				toth: newToth
			}
		case types.UPDATE_SELECTED_DATE:
			return {
				...state,
				selectedDate: action.payload
			}
		default:
			return state;
	}
};
